enum ApiKeyRole {
  Admin = "Admin",
  ReadOnly = "ReadOnly",
}

export const API_KEY_ROLE_OPTIONS: ApiKeyRole[] = Object.values(ApiKeyRole);

// Mirrors shared/src/dModels/utils/Constants.js API_KEY_DEFAULT_LIMITS. Keep
// in sync — the server still owns enforcement; this is for UI prefill.
export const API_KEY_DEFAULT_LIMITS: Record<
  ApiKeyRole,
  { sustainedPerHour: number; burst: number }
> = {
  [ApiKeyRole.Admin]: { sustainedPerHour: 3600, burst: 60 },
  [ApiKeyRole.ReadOnly]: { sustainedPerHour: 1800, burst: 30 },
};

export default ApiKeyRole;
